// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';
export let DirectEntitlementProductSubscriptionResponseMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_PFIX_PRODUCT_SUBSCRIPTION_MANAGEMENT_RESP)

    this.Id = -1;
    this.ReqType = null;
    this.ReqStatus = null;
    this.ReqTime = null;
    this.ResponseEnd = null;
    this.ErrorCode = null;
    this.Comment = null;
}

DirectEntitlementProductSubscriptionResponseMessage.prototype = Object.create(DirectMessageBase.prototype)